import { useState, useEffect } from "react";

import { makeStyles, Grid, Typography } from "@material-ui/core";

import { KPIS } from "../constants";
import { Icon } from "../../../components/base/Icon";
import { TonCo2 } from "../../../components/units/TonCo2";
import { ShaDowBox, CardBox } from "../../../components/boxes";
import TreesImg from "../../../assets/images/dashboard/trees.svg";
import { TwentyYear } from "../../../components/units/TwentyYear";
import {
  api,
  getPercent,
  nFormatter,
  requestDateFormat,
} from "../../../services";
import { LinearProgress } from "../../../components/base/LinearProgress";

const useStyles = makeStyles((theme) => ({
  container: {
    flexWrap: "noWrap",
  },
  icon: {
    marginRight: theme.spacing(1.5),
  },
}));

const initialData = {
  per_date: 0,
  per_20y: 0,
};

export const EmissionReductionKPI = ({
  activeKpi,
  setActiveKpi,
  period,
  startDate,
  endDate,
}) => {
  const classes = useStyles();
  const [data, setData] = useState(initialData);

  useEffect(() => {
    const getData = (url) => {
      api.get(url).then((resp) => setData(resp.data));
    };

    const getUrl = (period) => {
      let url = "/praas/v1/dashboard/emission-reduction/";
      if (period.name === "RANGE" && endDate) {
        url += `?from_date=${requestDateFormat(
          startDate
        )}&to_date=${requestDateFormat(endDate)}`;
        getData(url);
      } else if (["YTD", "Acc.", "20Y"].includes(period.name)) {
        url += `?date_filter=${period.filter}`;
        getData(url);
      }
    };

    getUrl(period);
  }, [period, startDate, endDate]);

  return (
    <Grid
      id="emission-reduction-kpi"
      item
      style={{ flex: 1 }}
      onClick={() => setActiveKpi(KPIS.emission_reduction)}
    >
      <ShaDowBox active={activeKpi === KPIS.emission_reduction} hoverable>
        <CardBox>
          <Grid className={classes.container} container>
            <Icon root={classes.icon} src={TreesImg} />
            <div>
              <Grid container>
                <Typography
                  color={
                    activeKpi === KPIS.emission_reduction
                      ? "primary"
                      : undefined
                  }
                  variant="h2"
                  style={{ fontWeight: "bold" }}
                >
                  {nFormatter(data.per_date)}
                </Typography>
                <TonCo2 style={{ position: "relative", top: 8, left: 4 }} />
              </Grid>
              <Typography>Carbon Emission Reduction</Typography>
            </div>
          </Grid>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={7}>
              <LinearProgress
                active={activeKpi === KPIS.emission_reduction}
                variant="determinate"
                value={getPercent(data.per_date, data.per_20y)}
              />
            </Grid>
            <Typography component="span" align="right">
              {nFormatter(data.per_20y)}
              <TonCo2 style={{ display: "inline", marginLeft: 4 }} />
            </Typography>
            <TwentyYear />
          </Grid>
        </CardBox>
      </ShaDowBox>
    </Grid>
  );
};
